import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({commit}, params) {
      try {
        const {data} = await axios.get('v1/intelbras/logs', {params});

        if (!data) {
          return []
        }

        commit('setData', data.data);
        return data;

      } catch (error) {
        console.error('Error fetching items:', error);
        return [];
      }
    },
    async add(_, params) {
      const {data} = await axios.post('v1/interbras/logs', params)

      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
